import { c as _c } from "react/compiler-runtime";
import { Button } from "@repo/ui/components/ui/button";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function NotFound() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = /*#__PURE__*/_jsxs("div", {
      className: "space-y-2",
      children: [/*#__PURE__*/_jsx("h1", {
        className: "text-4xl font-bold",
        children: "404"
      }), /*#__PURE__*/_jsx("h2", {
        className: "text-2xl font-semibold",
        children: "Sidan kunde inte hittas"
      }), /*#__PURE__*/_jsx("p", {
        className: "text-muted-foreground",
        children: "Tyv\xE4rr kunde vi inte hitta sidan du letar efter. Den kan ha flyttats eller tagits bort."
      })]
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col gap-2 sm:flex-row sm:justify-center",
      children: [/*#__PURE__*/_jsx(Button, {
        onClick: _temp,
        className: "w-full sm:w-auto",
        children: "G\xE5 till startsidan"
      }), /*#__PURE__*/_jsx(Button, {
        variant: "outline",
        onClick: _temp2,
        className: "w-full sm:w-auto",
        children: "G\xE5 tillbaka"
      })]
    });
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("h3", {
      className: "mb-2 font-semibold",
      children: "F\xF6rslag p\xE5 vad du kan g\xF6ra:"
    });
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = /*#__PURE__*/_jsx("div", {
      className: "flex min-h-screen flex-col items-center justify-center p-4",
      children: /*#__PURE__*/_jsxs("div", {
        className: "w-full max-w-md space-y-6 text-center",
        children: [t0, t1, /*#__PURE__*/_jsxs("div", {
          className: "rounded-lg border p-4",
          children: [t2, /*#__PURE__*/_jsxs("ul", {
            className: "list-inside list-disc space-y-2 text-left text-sm text-muted-foreground",
            children: [/*#__PURE__*/_jsx("li", {
              children: "Kontrollera att webbadressen \xE4r korrekt"
            }), /*#__PURE__*/_jsx("li", {
              children: "G\xE5 tillbaka till f\xF6reg\xE5ende sida"
            }), /*#__PURE__*/_jsx("li", {
              children: "G\xE5 till startsidan och b\xF6rja om"
            }), /*#__PURE__*/_jsx("li", {
              children: "Anv\xE4nd s\xF6kfunktionen f\xF6r att hitta det du letar efter"
            })]
          })]
        })]
      })
    });
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
function _temp2() {
  return window.history.back();
}
function _temp() {
  return window.location.href = "/";
}